export const primitiveUserSettingCodes = {
  CPV3_DASHBOARD_GRID_LAYOUT: 'CPV3_DASHBOARD_GRID_LAYOUT',
}
